import AlcoholConsumptionSummaryBlock from './Components/AlcoholConsumptionSummaryBlock.vue'
import AllergiesBlock from './Components/AllergiesBlock.vue'
import BodyTemperatureBlock from './Components/BodyTemperatureBlock.vue'
import BorgBreathlessnessScaleBlock from './Components/BorgBreathlessnessScaleBlock.vue'
import FamilyHistoryBlock from './Components/FamilyHistoryBlock.vue'
import ManagementPlanBlock from './Components/ManagementPlanBlock.vue'
import MedicationsBlock from './Components/MedicationsBlock.vue'
import PresentingComplaintBlock from './Components/PresentingComplaintBlock.vue'
import ProblemListBlock from './Components/ProblemListBlock.vue'
import PulseHeartBeatBlock from './Components/PulseHeartBeatBlock.vue'
import PulseOximetryBlock from './Components/PulseOximetryBlock.vue'
import TobaccoSmokingSummaryBlock from './Components/TobaccoSmokingSummaryBlock.vue'
import UhbModifiedAnthonisenCriteriaBlock from './Components/UhbModifiedAnthonisenCriteriaBlock.vue'

export default {
  'openEHR-EHR-EVALUATION.alcohol_consumption_summary.v1': AlcoholConsumptionSummaryBlock,
  'openEHR-EHR-EVALUATION.recommendation.v2': ManagementPlanBlock,
  'openEHR-EHR-EVALUATION.tobacco_smoking_summary.v1': TobaccoSmokingSummaryBlock,
  'openEHR-EHR-OBSERVATION.body_temperature.v2': BodyTemperatureBlock,
  'openEHR-EHR-OBSERVATION.borg_breathlessness_scale.v0': BorgBreathlessnessScaleBlock,
  'openEHR-EHR-OBSERVATION.pulse.v2': PulseHeartBeatBlock,
  'openEHR-EHR-OBSERVATION.pulse_oximetry.v1': PulseOximetryBlock,
  'openEHR-EHR-OBSERVATION.uhb_modified_anthonisen_criteria.v0': UhbModifiedAnthonisenCriteriaBlock,
  'openEHR-EHR-SECTION.adverse_reaction_list.v0': AllergiesBlock,
  'openEHR-EHR-SECTION.family_history.v0': FamilyHistoryBlock,
  'openEHR-EHR-SECTION.medication_list.v0': MedicationsBlock,
  'openEHR-EHR-SECTION.problem_list.v0': ProblemListBlock,
  'openEHR-EHR-OBSERVATION.story.v1': PresentingComplaintBlock,
}
